import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'coreComponents/design-system/flow-content';
import { Input, StyledButton } from 'coreComponents/design-system/Form';
import { Header, Paragraph } from 'coreComponents/design-system/typography';
import { isEmptyObject } from 'helpers/is-empty-object';
export const ResetPasswordForm = ({ serverErrors, }) => {
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (serverErrors && !isEmptyObject(serverErrors)) {
            setErrors(serverErrors);
        }
    }, []);
    const getErrorMessage = (field) => errors[field];
    const calculateFieldState = (field) => getErrorMessage(field) ? 'error' : 'normal';
    const handleSave = e => {
        const errorObj = {};
        if (password.length < 1) {
            errorObj['password'] = 'You must provide a new password.';
        }
        if (passwordConfirmation.length < 1) {
            errorObj['passwordConfirmation'] = 'You must confirm your new password.';
        }
        if (password !== passwordConfirmation) {
            errorObj['passwordConfirmation'] = 'The fields do not match.';
        }
        if (!isEmptyObject(errorObj)) {
            e.preventDefault();
            setErrors(errorObj);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Header.h2, { style: { marginBottom: '12px' }, className: "flex justify-center lg:justify-start" }, "RESET ACCOUNT PASSWORD"))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { marginBottom: '12px' }, className: "flex flex-column items-center lg:items-start" },
                    React.createElement("div", { className: "flex-shrink w-max" }, "Enter a new password"))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Paragraph, { style: { fontSize: '10px' } },
                        "REQUIRED ",
                        React.createElement("span", { style: { color: '#EF3A4C' } }, "*")))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Password", placeholder: "Password", name: "customer[password]", value: password, onChangeValue: setPassword, state: calculateFieldState('password'), errorMessage: getErrorMessage('password'), type: "password", required: true, mask: true }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Confirm Password", placeholder: "Confirm Password", name: "customer[password_confirmation]", value: passwordConfirmation, onChangeValue: setPasswordConfirmation, state: calculateFieldState('passwordConfirmation'), errorMessage: getErrorMessage('passwordConfirmation'), type: "password", required: true, mask: true }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(StyledButton, { type: "submit", onClick: handleSave, style: {
                            fontSize: '16px',
                            fontWeight: 600,
                            height: '40px',
                            minHeight: '40px',
                        } }, "Reset Password"))))));
};
ResetPasswordForm.defaultProps = {};
export default ResetPasswordForm;
